module.exports = __webpack_public_path__ + "img/pen.a42e0ae8.svg";